// ProductSectionValueAndWhere.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "../Style/ProductPage.css";

function safeArray(v) {
  return Array.isArray(v) ? v : [];
}

export default function ProductSectionValueAndWhere() {
  const { t } = useTranslation("product");
  const outcomes = safeArray(t("value.outcomes", { returnObjects: true }));
  const surfaces = safeArray(t("value.surfaces", { returnObjects: true }));

  return (
    <section className="life-section product-value" id="value">
      <div className="life-container">
        <div className="product-sectionHead">
          <div className="product-eyebrow">{t("value.eyebrow")}</div>
          <h2 className="product-h2">{t("value.title")}</h2>
          <p className="product-lead">{t("value.subtitle")}</p>
        </div>

        <div className="product-outcomesGrid">
          {outcomes.map((o, idx) => (
            <div key={idx} className="life-glass product-outcomeCard">
              <div className="product-outcomeTitle">{o.title}</div>

              <div className="product-outcomeRow">
                <div className="product-outcomeCol">
                  <div className="product-miniLabel">{t("value.before")}</div>
                  <div className="product-outcomeText">{o.before}</div>
                </div>
                <div className="product-outcomeCol">
                  <div className="product-miniLabel">{t("value.after")}</div>
                  <div className="product-outcomeText">{o.after}</div>
                </div>
              </div>

              <div className="product-outcomeProof">{o.proof}</div>
            </div>
          ))}
        </div>

        <div className="life-glass product-surfaces">
          <div className="product-surfacesHead">
            <h3 className="product-h3">{t("value.where_title")}</h3>
            <p className="product-p muted">{t("value.where_subtitle")}</p>
          </div>

          <div className="product-surfacesGrid">
            {surfaces.map((s, idx) => (
              <div key={idx} className="product-surfaceCard">
                <div className="product-surfaceTitle">{s.title}</div>
                <div className="product-surfaceText">{s.text}</div>
                <div className="product-surfaceTags">
                  {safeArray(s.tags).map((tag, i) => (
                    <span key={i} className="product-chip">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="product-finalCta">
            <div className="product-ctaRow">
              <a className="life-ctaPrimary" href={t("value.cta_primary.href")}>
                {t("value.cta_primary.label")}
              </a>
              <a className="product-ctaSecondary" href={t("value.cta_secondary.href")}>
                {t("value.cta_secondary.label")}
              </a>
            </div>
            <p className="life-ctaMeta">{t("value.reassurance")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
